import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=1d761555"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports